export default __webpack_public_path__ + "static/media/pictogramBeaconHelp40.431a4ddd.svg";